export function x(d) {
  return d[0];
}

export function y(d) {
  return d[1];
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-voronoi/src/point.js
// module id = 1623
// module chunks = 0